import { render, staticRenderFns } from "./breadcrumbSearch.vue?vue&type=template&id=f5068ddc&scoped=true"
import script from "./breadcrumbSearch.vue?vue&type=script&lang=js"
export * from "./breadcrumbSearch.vue?vue&type=script&lang=js"
import style0 from "./breadcrumbSearch.vue?vue&type=style&index=0&id=f5068ddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5068ddc",
  null
  
)

export default component.exports